"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var PromotionsController =
/*#__PURE__*/
function () {
  function PromotionsController(loadedData) {
    _classCallCheck(this, PromotionsController);

    this.promotionsList = loadedData.promotionsList;
    this.container = $('#promotions');
    this.renderPromotions();
  }

  _createClass(PromotionsController, [{
    key: "renderPromotions",
    value: function renderPromotions() {
      var _this = this;

      this.promotionsList = Object.values(this.promotionsList);
      this.promotionsList.forEach(function (promotion) {
        _this.container.append('<div class="gr-4 gr-6@mobile gr-12@mobileSmall"><div class="card">' + '<a href="' + promotion.link + '" target="_blank"><div class="image-wrapper"><div style="background-image: url(https://creativenow.cz' + promotion.image + ');" class="image"></div></div>' + '<h3>' + promotion.title + '</h3></a>' + promotion.descr + '</div></div>');
      });
    }
  }]);

  return PromotionsController;
}();